import StatusFilter from '../StatusFilter'
import { ALL_STATUS_OPTIONS } from '../../../netlify/functions/lib/bug-management/statuses'

interface BugStatusFilterProps {
  value: string
  onChange: (value: string) => void
}

export default function BugStatusFilter({ value, onChange }: BugStatusFilterProps) {
  return (
    <StatusFilter
      value={value}
      onChange={onChange}
      options={ALL_STATUS_OPTIONS}
      label="Status"
      analyticsPrefix="bug-status-filter"
    />
  )
}
